import { createElement, forwardRef } from 'react';

export type TextProps = {
  field: string | undefined;
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
};

const Text = forwardRef<HTMLDivElement, TextProps>(function BaseHelpersText(
  props: TextProps,
  ref
): JSX.Element {
  const { field, tag = 'span', className } = props || {};

  if (!field) return <></>;

  if (field) {
    return createElement(tag, {
      className,
      ref: ref,
      dangerouslySetInnerHTML: {
        __html: field,
      },
    });
  }
  return <></>;
});

export default Text;
